/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:59:48
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-13 22:28:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/Table/col.tsx
 */
import React from 'react';
import { Select } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
// const _Select = (props) => {
//     const {onDropDown}=props;
//   const [options, setOptions] = React.useState([]);

//   return <Select />
// };
const col = (canMove, onMove, moveList, { getI18n }) => {
  return [
    {
      title: '',
      dataIndex: 'thumbnailImageUrl',
      key: 'thumbnailUrl',
      default: true,
      optional: false,
      childGenerate: (url) => (
        <img key={url} src={url} width={48} height={48} />
      ),
      width: 56,
    },
    {
      title: getI18n('general.productName'),
      dataIndex: 'productName',
      key: 'productName',
      default: true,
      optional: false,
      // childGenerate: (url) => (
      //   <img key={url} src={url} width={48} height={48} />
      // ),
      minWidth: 250,
    },
    {
      title: getI18n('general.type'),
      dataIndex: 'alias',
      key: 'alias',
      default: true,
      optional: false,
      childGenerate: (alias) => {
        const text = alias
          ? getI18n('general.alias')
          : getI18n('general.original');
        return text;
      },
      minWidth: 56,
    },
    {
      title: getI18n('general.remarks'),
      dataIndex: 'remarks',
      key: 'remarks',
      default: true,
      optional: false,
      childGenerate: (remarks) => {
        return (
          <NoWrapContainer>
            <GlobalTooltip title={remarks || ''}>
              {remarks || '-'}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      minWidth: 250,
    },
    {
      title: getI18n('salesChannelCategoryProducts.index.slug'),
      dataIndex: 'slug',
      key: 'slug',
      default: true,
      optional: false,
      childGenerate: (slug) => {
        return (
          <NoWrapContainer>
            <GlobalTooltip title={slug || ''}>{slug || '-'}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      minWidth: 150,
    },
    canMove && {
      titleGenerate: () =>
        getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),

      key: 'moveTo',
      default: true,
      optional: false,
      position: EnumTablePosition.mid,
      childGenerate: (slug, record) => {
        const { uuid } = record;
        return (
          <Select
            getPopupContainer={() => document.body}
            className={css.moveTo}
            placeholder={getI18n('salesChannelCategoryProducts.index.moveto')}
            onChange={(e) => {
              onMove({ productUuid: uuid, target: e });
            }}
            optionsList={moveList.map((i) => {
              const { label, value, suffix } = i;
              return { label: suffix + label, value };
            })}
          />
        );
      },
      width: 130,
    },
  ];
};
export { col };
